import React from 'react';
import EditButton from 'components/ActionButtons/editButton';
import DeleteButton from 'components/ActionButtons/deleteButton';
import Table from 'components/Table';
import dayjs from 'dayjs';
import { t } from 'i18next';
function List({ headers, data, onEdit, buttons, onDelete }) {
  return (
    <Table
      title={t('sidebar.location')}
      subtitle={t('region')}
      buttons={buttons}
      headers={headers.map((e) => (
        <th scope='col' key={`thead-${Math.random()}`}>
          {t(e)}
        </th>
      ))}
      data={data}
      rows={data.map((e, index) => (
        <tr key={`table-row-${Math.random()}`}>
          <td>{index + 1}</td>
          <td>{e.name}</td>
          <td>{e.country.name}</td>
          <td>{dayjs(e.createdAt).format('DD/MM/YYYY HH:mm')}</td>
          <td>{e.modifiedBy?.name}</td>
          <td>
            <EditButton onClick={() => onEdit(e)} />
            <DeleteButton onClick={() => onDelete(e)} />
          </td>
        </tr>
      ))}
    />
  );
}

export default List;
